export const iconFontAwesomeChildhoodChild = (
	<i className="fa-solid fa-child"></i>
);
